"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyDiagramSelector = exports.ExcelModal = exports.ApplySaveJSONDialog = exports.ApplyLayoutDialog = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyConvert_1 = require("../configmenus/SankeyConvert");
const SankeyUtils_1 = require("../configmenus/SankeyUtils");
const SankeyDrawFunction_1 = require("../draw/SankeyDrawFunction");
const SankeyDrawLayout_1 = require("../draw/SankeyDrawLayout");
const SankeyMenuTop_1 = require("../topmenus/SankeyMenuTop");
const fa_1 = require("react-icons/fa");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_2 = require("@chakra-ui/react");
/**
 *
 * @param {ApplyLayoutDialogTypes} { ref_setter_show_apply_layout, set_show_apply_layout, sankey_data, set_sankey_data }
 * @returns {*}
 */
const ApplyLayoutDialog = ({ t, dict_hook_ref_setter_show_dialog_components, dict_variable_application_data, updateLayout, convert_data, diagramSelector, elementToDispose, apply_transformation_additional_elements, DefaultSankeyData }) => {
    const { data, set_data } = dict_variable_application_data;
    const [prev_sankey_data, set_prev_sankey_data] = (0, react_1.useState)(data);
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(true);
    const [stretchFactorH, set_stretchFactorH] = (0, react_1.useState)(1);
    const [stretchFactorV, set_stretchFactorV] = (0, react_1.useState)(1);
    const [mode_trans, set_mode_trans] = (0, react_1.useState)('simple');
    const [node_hspace, set_node_hspace] = (0, react_1.useState)(data.h_space);
    const [node_vspace, set_node_vspace] = (0, react_1.useState)(data.v_space);
    if (node_hspace !== data.h_space) {
        set_node_hspace(data.h_space);
    }
    if (node_vspace !== data.v_space) {
        set_node_vspace(data.v_space);
    }
    const node_visible = (0, SankeyDrawFunction_1.NodeVisibleOnsSvg)();
    const all_element_to_transform = [
        'addNode', 'addFlux', 'removeNode', 'removeFlux',
        'posNode', 'posFlux',
        'Values',
        'attrNode', 'attrFlux',
        'tagNode', 'tagFlux', 'tagData', 'tagLevel',
        'attrGeneral'
    ];
    const advanced_element_to_transform = [
        'addNode', 'addFlux', 'removeNode', 'removeFlux',
        'posNode', 'posFlux',
        'Values',
        'attrNode', 'attrFlux',
        'attrGeneral'
    ];
    const simple_element_to_transform = [
        'posNode', 'posFlux',
        'attrNode', 'attrFlux',
        'attrGeneral'
    ];
    const default_element_to_transform = [
        'posNode', 'posFlux',
        'attrNode', 'attrFlux',
        'attrGeneral'
    ];
    const applyStretch = (param) => {
        const attr = param == 'h' ? 'x' : 'y';
        const stretchFactor = param == 'h' ? stretchFactorH : stretchFactorV;
        let min = Object.values(data.nodes)[0][attr];
        // Cheche la position en y du noeud le plus en haut à gauche
        Object.values(data.nodes).filter(n => node_visible.includes(n.idNode) && n.position != 'relative').forEach(n => {
            min = (n[attr] < min) ? n[attr] : min;
        });
        // Parcours les noeuds --> calcule le delta des position en y entre ceux-ci --> multiplie le delta par le facteur du input -->
        // applique le delta mutiplié par le facteur au noeud
        Object.values(data.nodes).filter(n => node_visible.includes(n.idNode) && n.position != 'relative').forEach(n => {
            const delta = n[attr] - min;
            n[attr] = min + (delta * stretchFactor);
        });
        set_data(Object.assign({}, data));
    };
    const content_modal_layout = react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: 'import' },
        react_1.default.createElement(react_bootstrap_1.Tab, { key: 'import', eventKey: 'import', title: t('Menu.Transformation.amp_import'), style: { marginBottom: '10px' } },
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '50%' } }, t('Menu.choseTransforDifficulty')),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: mode_trans == 'simple' ? 'primary' : 'outline-primary', style: { width: 50 / 3 + '%' }, onClick: () => { set_mode_trans('simple'); } }, "Simple"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: mode_trans == 'avancé' ? 'warning' : 'outline-warning', style: { width: 50 / 3 + '%' }, onClick: () => { set_mode_trans('avancé'); } }, t('Avancé')),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: mode_trans == 'expert' ? 'danger' : 'outline-danger', style: { width: 50 / 3 + '%' }, onClick: () => { set_mode_trans('expert'); } }, "Expert")),
            diagramSelector(t, convert_data, data, set_data, prev_sankey_data, set_prev_sankey_data, updateLayout, elementToDispose, DefaultSankeyData),
            react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.Shortcuts') },
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.Shortcuts')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: 'outline-primary', onClick: () => {
                            elementToDispose.current.length = 0;
                            setForceUpdate(!forceUpdate);
                        } }, t('Menu.Transformation.unSelectAll')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: 'outline-primary', onClick: () => {
                            elementToDispose.current.length = 0;
                            if (mode_trans === 'simple') {
                                simple_element_to_transform.forEach(el => elementToDispose.current.push(el));
                            }
                            else if (mode_trans === 'avancé') {
                                advanced_element_to_transform.forEach(el => elementToDispose.current.push(el));
                            }
                            else {
                                all_element_to_transform.forEach(el => elementToDispose.current.push(el));
                            }
                            setForceUpdate(!forceUpdate);
                        } }, t('Menu.Transformation.selectAll')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: 'outline-primary', onClick: () => {
                            elementToDispose.current.length = 0;
                            default_element_to_transform.forEach(el => elementToDispose.current.push(el));
                            setForceUpdate(!forceUpdate);
                        } }, t('Menu.Transformation.selectDefault')))),
            mode_trans != 'simple' ?
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.Topology') },
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.Topology')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('addNode') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('addNode')) {
                                    elementToDispose.current.push('addNode');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('addNode'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.addNode')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('removeNode') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('removeNode')) {
                                    elementToDispose.current.push('removeNode');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('removeNode'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.removeNode')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('addFlux') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('addFlux')) {
                                    elementToDispose.current.push('addFlux');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('addFlux'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.addFlux')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('removeFlux') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('removeFlux')) {
                                    elementToDispose.current.push('removeFlux');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('removeFlux'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.removeFlux')))) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.Geometry') },
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.Geometry')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('posNode') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!elementToDispose.current.includes('posNode')) {
                                elementToDispose.current.push('posNode');
                                setForceUpdate(!forceUpdate);
                            }
                            else {
                                elementToDispose.current.splice(elementToDispose.current.indexOf('posNode'), 1);
                                setForceUpdate(!forceUpdate);
                            }
                        } }, t('Menu.Transformation.PosNoeud')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('posFlux') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!elementToDispose.current.includes('posFlux')) {
                                elementToDispose.current.push('posFlux');
                                setForceUpdate(!forceUpdate);
                            }
                            else {
                                elementToDispose.current.splice(elementToDispose.current.indexOf('posFlux'), 1);
                                setForceUpdate(!forceUpdate);
                            }
                        } },
                        " ",
                        t('Menu.Transformation.posFlux')))),
            mode_trans != 'simple' ?
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.Values') },
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.Values')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('Values') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('Values')) {
                                    elementToDispose.current.push('Values');
                                    // Also need dataTags because we can't only import values without the structur of dataTags
                                    // (but we can import dataTags without values)
                                    if (!elementToDispose.current.includes('tagData')) {
                                        elementToDispose.current.push('tagData');
                                    }
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('Values'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, elementToDispose.current.includes('Values') ? react_1.default.createElement(fa_1.FaCheck, null) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark })))) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.Attribut') },
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.Attribut')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('attrNode') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!elementToDispose.current.includes('attrNode')) {
                                elementToDispose.current.push('attrNode');
                                setForceUpdate(!forceUpdate);
                            }
                            else {
                                elementToDispose.current.splice(elementToDispose.current.indexOf('attrNode'), 1);
                                setForceUpdate(!forceUpdate);
                            }
                        } }, t('Menu.Transformation.attrNode')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('attrFlux') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!elementToDispose.current.includes('attrFlux')) {
                                elementToDispose.current.push('attrFlux');
                                setForceUpdate(!forceUpdate);
                            }
                            else {
                                elementToDispose.current.splice(elementToDispose.current.indexOf('attrFlux'), 1);
                                setForceUpdate(!forceUpdate);
                            }
                        } }, t('Menu.Transformation.attrFlux')))),
            mode_trans == 'expert' ?
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.Tags') },
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.Tags')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('tagNode') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('tagNode')) {
                                    elementToDispose.current.push('tagNode');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('tagNode'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.tagNode')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('tagFlux') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('tagFlux')) {
                                    elementToDispose.current.push('tagFlux');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('tagFlux'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.tagFlux')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('tagData') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('tagData')) {
                                    elementToDispose.current.push('tagData');
                                    setForceUpdate(!forceUpdate);
                                }
                                else if (!elementToDispose.current.includes('Values')) {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('tagData'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, t('Menu.Transformation.tagData')))) : react_1.default.createElement(react_1.default.Fragment, null),
            mode_trans == 'expert' ?
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.tagLevel') },
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.tagLevel')),
                        react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('tagLevel') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!elementToDispose.current.includes('tagLevel')) {
                                    elementToDispose.current.push('tagLevel');
                                    setForceUpdate(!forceUpdate);
                                }
                                else {
                                    elementToDispose.current.splice(elementToDispose.current.indexOf('tagLevel'), 1);
                                    setForceUpdate(!forceUpdate);
                                }
                            } }, elementToDispose.current.includes('tagLevel') ? react_1.default.createElement(fa_1.FaCheck, null) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark })))) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.Transformation.tooltips.attrGeneral') },
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('Menu.Transformation.attrGeneral')),
                    react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', style: { width: '20%' }, variant: elementToDispose.current.includes('attrGeneral') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!elementToDispose.current.includes('attrGeneral')) {
                                elementToDispose.current.push('attrGeneral');
                                setForceUpdate(!forceUpdate);
                            }
                            else {
                                elementToDispose.current.splice(elementToDispose.current.indexOf('attrGeneral'), 1);
                                setForceUpdate(!forceUpdate);
                            }
                        } }, elementToDispose.current.includes('attrGeneral') ? react_1.default.createElement(fa_1.FaCheck, null) : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faXmark })))),
            apply_transformation_additional_elements.map((c, i) => {
                return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
            })),
        react_1.default.createElement(react_bootstrap_1.Tab, { key: 'manuelle', eventKey: 'manuelle', title: t('Menu.Transformation.amp_manuelle'), style: { marginBottom: '10px' } },
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('MEP.Horizontal')),
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('MEP.tooltips.EEN_h') },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: node_hspace, onChange: evt => {
                            set_node_hspace(+evt.target.value);
                            data.h_space = +evt.target.value;
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '20%' } }, t('MEP.Vertical')),
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('MEP.tooltips.EEN_v') },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: node_vspace, onChange: evt => {
                            set_node_vspace(+evt.target.value);
                            data.v_space = +evt.target.value;
                        } }))),
            react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('MEP.tooltips.factExpH') },
                react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('MEP.factExpH')),
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'number', min: 0, step: 0.1, value: stretchFactorH, onChange: evt => {
                                set_stretchFactorH(+evt.target.value);
                            } }),
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-primary', onClick: () => applyStretch('h') }, t('MEP.stretchH'))))),
            react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('MEP.tooltips.factExpV') },
                react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('MEP.factExpV')),
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'number', min: 0, step: 0.1, value: stretchFactorV, onChange: evt => {
                                set_stretchFactorV(+evt.target.value);
                            } }),
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-primary', onClick: () => applyStretch('v') }, t('MEP.stretchV'))))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('MEP.tooltips.PA') },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            dict_variable_application_data.function_on_wait.current = () => {
                                (0, SankeyDrawLayout_1.ComputeAutoSankey)(data, node_hspace, false);
                                set_data(Object.assign({}, data));
                            };
                            dict_hook_ref_setter_show_dialog_components.ref_setter_show_waiting.current(true);
                        } }, t('MEP.PA'))),
                react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('MEP.tooltips.AN') },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                            (0, SankeyDrawLayout_1.arrangeNodes)(data);
                            set_data(Object.assign({}, data));
                        } }, t('MEP.AN'))))),
        react_1.default.createElement(react_bootstrap_1.Tab, { key: 'trans_topo', eventKey: 'trans_topo', title: t('Menu.Transformation.trans_topo'), style: { marginBottom: '10px' } }));
    const dragLayout = (0, SankeyMenuTop_1.MenuDraggable)(dict_hook_ref_setter_show_dialog_components, 'ref_setter_show_apply_layout', content_modal_layout, { current: [window.innerWidth / 4, window.innerHeight / 4] }, t('Menu.Transformation.title'), 60);
    return dragLayout;
};
exports.ApplyLayoutDialog = ApplyLayoutDialog;
/**
 *
 * @param {ApplySaveJSONTypes} { ref_setter_show_save_json, set_show_save_json,sankey_data,set_sankey_data,ClickSaveDiagram }
 * @returns {*}
 */
const ApplySaveJSONDialog = ({ t, dict_hook_ref_setter_show_dialog_components, sankey_data, additionnal_button_option_save_json, ClickSaveDiagram }) => {
    const [mode_save, set_mode_save] = (0, react_1.useState)(true);
    const [mode_visible_element, set_mode_visible_element] = (0, react_1.useState)(false);
    const [show_save_json_modal, set_show_save_json_modal] = (0, react_1.useState)(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_save_json.current = set_show_save_json_modal;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_save_json_modal, onHide: () => set_show_save_json_modal(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.SaveJSON'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Label, null,
                    react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), maxW: '40%', isChecked: mode_save, onChange: () => set_mode_save(!mode_save) }, t('Menu.SaveValue'))),
                react_1.default.createElement(react_bootstrap_1.Form.Label, null,
                    react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), maxW: '40%', isChecked: mode_visible_element, onChange: () => set_mode_visible_element(!mode_visible_element) }, t('Menu.VisibleElement'))),
                additionnal_button_option_save_json)),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", style: { width: '20%' }, variant: 'danger', onClick: () => {
                    set_show_save_json_modal(false);
                } }, t('Menu.close')),
            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", style: { width: '20%' }, onClick: () => {
                    // Crée une copie pour d'abord enregitrer avec les changements
                    // (ClickSaveDiagram utilise data donc on doit faire un set_data avant mais aussi garder la version sans les changements)
                    const cpy = JSON.parse(JSON.stringify(sankey_data));
                    if (!mode_save) {
                        Object.values(cpy.links).forEach(d => {
                            d.value = {};
                        });
                    }
                    if (mode_visible_element) {
                        // Si l'on enregistre que les element visible alors on cherche les élements visible dasns le svg
                        const link_present = (0, SankeyDrawFunction_1.LinkVisibleOnSvg)();
                        const node_visible = (0, SankeyDrawFunction_1.NodeVisibleOnsSvg)();
                        cpy.links = Object.fromEntries(Object.entries(cpy.links).filter(l => link_present.includes(l[0])).map(l => l));
                        const key_level_tags = Object.keys(sankey_data.levelTags);
                        cpy.nodes = Object.fromEntries(Object.entries(cpy.nodes).filter(n => node_visible.includes(n[0])).map(n => {
                            key_level_tags.forEach(klt => {
                                delete n[1].tags[klt];
                            });
                            n[1].dimensions = {};
                            n[1].inputLinksId = n[1].inputLinksId.filter(lid => link_present.includes(lid));
                            n[1].outputLinksId = n[1].outputLinksId.filter(lid => link_present.includes(lid));
                            return n;
                        }));
                        cpy.levelTags = {};
                        cpy.linkZIndex = link_present;
                        cpy.view = [];
                    }
                    // set_sankey_data({...sankey_data})
                    ClickSaveDiagram(cpy);
                    // set_sankey_data({...cpy})
                } }, t('Menu.SaveJSON')))));
};
exports.ApplySaveJSONDialog = ApplySaveJSONDialog;
/**
 * Return the modal when we try to open an excel file
 *
 * @param {{ UploadExcelImpl: any; handleCloseDialog: any; set_data: any; data: any; set_show_excel_dialog: any; url_prefix: any; callback: any; launch: any; }} { UploadExcelImpl, handleCloseDialog, set_data, data, set_show_excel_dialog,url_prefix,callback,launch }
 * @returns
 */
const ExcelModal = ({ t, UploadExcelImpl, url_prefix, launch, dict_hook_ref_setter_show_dialog_components, Reinitialization, pointer_pos }) => {
    const [input_file_name, set_input_file_name] = (0, react_1.useState)(undefined);
    const content = react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_grid' },
        react_1.default.createElement(react_2.Box, null,
            t('Menu.input_file_excel'),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => {
                    set_input_file_name(evt.target.files[0]);
                } })),
        react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_row_2cols' },
            react_1.default.createElement(react_2.Box, null),
            react_1.default.createElement(react_2.Button, { variant: "menuconfigpanel_option_button", onClick: () => {
                    Reinitialization();
                    launch(input_file_name.name);
                    UploadExcelImpl(dict_hook_ref_setter_show_dialog_components.ref_setter_show_excel_dialog.current, input_file_name, url_prefix);
                } }, t('Menu.ouvrir'))));
    return (0, SankeyMenuTop_1.MenuDraggable)(dict_hook_ref_setter_show_dialog_components, 'ref_setter_show_excel_dialog', content, pointer_pos, t('Menu.open_excel_file'));
};
exports.ExcelModal = ExcelModal;
const OpenSankeyDiagramSelector = (t, convert_data, sankey_data, set_sankey_data, prev_sankey_data, set_prev_sankey_data, updateLayout, elementToDispose, defaultData) => {
    const [file_layout, set_file_layout] = (0, react_1.useState)(undefined);
    return react_1.default.createElement(react_bootstrap_1.Form, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: '3' },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.Transformation.fmep'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: '2' },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", onChange: (evt) => set_file_layout(evt.target.files) })),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                        if (file_layout === undefined) {
                            return;
                        }
                        const reader = new FileReader();
                        reader.onload = (() => {
                            return ((e) => {
                                let result = e.target.result;
                                if (result) {
                                    result = String(result);
                                    const new_layout = JSON.parse(result);
                                    convert_data(new_layout, defaultData);
                                    (0, SankeyConvert_1.complete_sankey_data)(new_layout, defaultData, SankeyUtils_1.DefaultNode, SankeyUtils_1.DefaultLink);
                                    set_prev_sankey_data(JSON.parse(JSON.stringify(sankey_data)));
                                    updateLayout(sankey_data, new_layout, elementToDispose.current, true);
                                    set_sankey_data(Object.assign({}, sankey_data));
                                }
                            });
                        })();
                        reader.readAsText(file_layout[0]);
                    } }, t('Menu.Transformation.ad'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", onClick: () => {
                        set_sankey_data(JSON.parse(JSON.stringify(prev_sankey_data)));
                    } }, t('Menu.Transformation.undo')))));
};
exports.OpenSankeyDiagramSelector = OpenSankeyDiagramSelector;
